export const getTranslatedText = (
  translations: Record<string, Record<string, string>>,
  key: string,
  language: string
): string => {
  const translation = translations[key];
  if (!translation) return key;
  return translation[language] || translation.fr || key;
};

export const getTranslatedCategory = getTranslatedText;
